import React from 'react'
import styled from 'styled-components'
import { PartnersSlider } from './partners_slider';
import { colors } from '../../styles/colors';

const Container = styled.div`
    border-top: 1px solid ${colors.dark_blue};
    padding: 8.75rem 2rem 25rem 2rem;

    @media (max-width: 320px) {
        padding: 3.75rem 2rem 10rem 2rem;
    }

    // INCLUDED CLASSES:

    .title {
        font-family: 'SF UI Text', sans-serif;
        font-weight: 400;
        font-size: 8rem;
        line-height: 125%;
        color: ${colors.dark_blue};
        text-transform: uppercase;
        text-align: center;
        margin-bottom: 11.25rem;

        @media (max-width: 320px) {
            font-size: 6rem;
            text-align: start;
            margin-bottom: 5rem;
        }
    }
`;

export const Partners = () => {
    return (
        <Container>
            <p className='title'>наши партнеры</p>
            <PartnersSlider />
        </Container>
    )
}
